<template>
  <div class="plan-model training-wrapper" v-if="visible">
    
    <div v-if="showTutorial" style="width:570px" class="select-chapter">
      <div class="close-chapter">
        <span @click="closeChapter"><i class="el-icon-close"></i></span>
      </div>
      <div class="header" style="margin-bottom:0">
          <p></p>
          <h1>选择教程章节</h1>
      </div>
      <div style="height:400px">
        <addtrainingTutorial
          ref="addtrainingComp"
          v-show="showTutorial"
          :isRelatePush="false"
          @receiveTutorial="receiveTutorial"
        ></addtrainingTutorial>
      </div>
      <div slot="footer" style="margin-top:26px;text-align:center;">
        <el-button @click="resetChoose">重置</el-button>
        <el-button type="primary" @click="confirmAdd" style="background:#1A7BFC;border-color:#1A7BFC">确认添加</el-button>
      </div>
    </div>

    <div style="width:470px">
      <div class="title">
        <p></p>
        <h3>{{ title }}</h3>
      </div>
      <div class="content">
        <!--  label-suffix="：" -->
        <el-scrollbar style="height: 100%">
          <el-form :model="form" :rules="rules" ref="ruleForm" label-width="122px" size="small" class="demo-ruleForm">
            <el-form-item label="训练教程" prop='courseName'>
              <el-select v-model="form.courseName" value-key="id" placeholder="请选择训练教程" @change="chosecourse" clearable>
                <el-option v-for="(item,index) in coursearr" :key="index" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="教程章节" required>
              <!-- <el-select v-model="form.itemName" value-key="id" placeholder="请选择教程章节" clearable @input="change($event)"
                @change="chosecourseOne">
                <el-option v-for="(item,index) in catalog" :key="index" :label="item.name" :value="item"></el-option>
              </el-select> -->
              <el-table v-if="addChapterData.length" :data="addChapterData" max-height="200" style="margin-bottom:10px">
                <el-table-column prop="chapterNo" label="编号" align="center"></el-table-column>
                <el-table-column prop="label" label="章节标题" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examPaperTitle" label="类型" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 1">目录</span>
                    <span v-if="scope.row.type == 2">章节内容</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-if="addChapterData.length" size="small" type="primary" style="background:#1A7BFC;border-color:#1A7BFC;margin-right:20px" @click="updateChoseChapter">修改教程章节</el-button>
              <el-button v-else size="small" type="primary" style="background:#1A7BFC;border-color:#1A7BFC;margin-right:20px" @click="choseChapter">选择教程章节</el-button>
            </el-form-item>
            <el-form-item label="训练总时长" v-if="form.attrs == 1" prop='days'>
              <el-input placeholder="请输入时间 " v-model.trim="form.days" :maxlength="6" class="input-with-select">
                <el-select v-model="form.daysType" slot="append" placeholder="" style="width:70px">
                  <el-option label="天" value="天"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="单次训练时长" prop='three'>
              <div style="display:flex">
                <el-input style="width:40%" v-model.trim="form.one" :maxlength="6" placeholder="范围" @input="change($event)">
                </el-input>
                <span style="margin:0px 10px">-</span>
                <el-input placeholder="范围 " v-model.trim="form.two" :maxlength="6" @input="change($event)"
                  class="input-with-select" style="width:43%">
                  <el-select v-model="form.three" slot="append" @input="change($event)" placeholder="" style="width:65px">
                    <el-option label="秒" value="秒"></el-option>
                    <el-option label="分" value="分"></el-option>
                    <el-option label="小时" value="小时"></el-option>
                  </el-select>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="提醒时间：">
              <!-- <div style="display:flex;align-items: center;" v-if="edit"> -->
              <div style="display:flex;align-items: center;">
                <span style="display: block;width: 40px;">提前</span>
                <el-input placeholder="请输入内容" v-model="form.itemTime" maxlength="2" @input="itemTimeChange">
                  <template slot="append">天</template>
                </el-input>
              </div>
              <!-- <span v-else>{{ form.itemTime }}</span> -->
            </el-form-item>
            <el-form-item label="训练频率" prop='cycle'>
              <div class="cycle-count-style">
                <el-input maxlength="20" type="text" :disabled="form.cycleType == '时'"
                  placeholder="请输入时长" v-model.trim="form.cycle" clearable style="width:90px;flex:unset"></el-input>
                <el-select v-model="form.cycleType" :disabled="form.cycleType == '时'" placeholder="请选择" clearable style="width:70px;margin:0 10px">
                    <el-option label="日" value="日"></el-option>
                    <el-option label="周" value="周"></el-option>
                    <el-option label="月" value="月"></el-option>
                </el-select>
                <el-input maxlength="20" type="text" :disabled="form.cycleType == '时'" placeholder="请输入" v-model.trim="form.cycleCount">
                  <template slot="append">次</template>
                </el-input>
              </div>
              <!-- <el-select v-model="form.cycle" placeholder="请选择频率" clearable>
                <el-option label="每日一次" value="QD"></el-option>
                <el-option label="每日两次" value="BID"></el-option>
                <el-option label="每日三次" value="TID"></el-option>
                <el-option label="每日四次" value="QID"></el-option>
                <el-option label="隔日一次" value="QOD"></el-option>
                <el-option label="每周一次" value="QW"></el-option>
                <el-option label="每周两次" value="BIW"></el-option>
                <el-option label="每周三次" value="TIW"></el-option>
                <el-option label="隔周一次" value="QOW"></el-option>
                <el-option label="每两周一次" value="2W"></el-option>
                <el-option label="每三周一次" value="3W"></el-option>
                <el-option label="每四周一次" value="4W"></el-option>
                <el-option label="每半小时一次" value="Q1/2H"></el-option>
                <el-option label="每小时一次" value="QH"></el-option>
                <el-option label="两小时一次" value="Q2H"></el-option>
                <el-option label="三小时一次" value="Q3H"></el-option>
                <el-option label="四小时一次" value="Q4H"></el-option>
                <el-option label="六小时一次" value="Q6H"></el-option>
                <el-option label="八小时一次" value="Q8H"></el-option>
                <el-option label="12小时一次" value="Q12H"></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="训练属性" prop='attrs'>
              <el-radio-group v-model="form.attrs">
                <el-radio :label="1">长期</el-radio>
                <el-radio :label="2">短期</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="短期训练属性" v-if="form.attrs == 2" prop='shortDays'>
              <el-input placeholder="请输入时间 " v-model.trim="form.shortDays" :maxlength="6" class="input-with-select">
                <el-select v-model="form.shortDaysType" slot="append" placeholder="" style="width:70px">
                  <el-option label="天" value="天"></el-option>
                  <el-option label="周" value="周"></el-option>
                  <el-option label="月" value="月"></el-option>
                  <el-option label="年" value="年"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="开始时间类型" prop='startTimeType'>
              <el-select v-model="form.startTimeType" placeholder="请选择方案开始时间">
                <el-option v-for="item in startTimeTypeList" :key="item.id" :label="item.name"
                  :value="item.startTimeType">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="与开始时间间隔" prop='startIntervalTime'>
              <el-input placeholder="请输入开始时间间隔" v-model.trim="form.startIntervalTime" :maxlength="6" class="input-with-select">
                <el-select v-model="form.startIntervalType" slot="append" placeholder="" style="width:70px">
                  <el-option label="天" value="天"></el-option>
                  <el-option label="周" value="周"></el-option>
                  <el-option label="月" value="月"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="addChapterData = [];form={attrs:2,moduleCode:'JRTX',isTop:2,shortDaysType:'天',startIntervalType:'天',three:'秒',daysType:'天',itemType: 2,itemTime:'',remindDate:''}">重置</el-button>
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import addtrainingTutorial from "@/views/ToolMaintenance/component/addtrainingTutorial";
import local from "@/utils/local.js";
import { api_get_train_chapter, api_get_train_course } from "../api/index";

export default {
  name: "Training",
  components:{
    addtrainingTutorial
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "功能训练方案"
    },
    formData: {
      type: Object,
      default: () => {}
    },
     startTimeTypeList:{
       type: Array,
       default: () => []
    }
  },
  data() {
    let checkCycle = (rule, value, callback) => {
      if (!value || !this.form.cycleType || !this.form.cycleCount) {
        return callback(new Error('请填写频率'));
      } else {
        // oninput="value=value.replace(/[^\d.]/g,'')"
        let valiReg = /^\+?[1-9]\d*$/
        if (!valiReg.test(value) || !valiReg.test(this.form.cycleCount)) {
          return callback(new Error('请输入正整数'));
        }
        if (Number(this.form.cycleCount) > 99) {
          return callback(new Error('次数限制1-99次'));
        }

        if (this.form.cycleType == '日') {
          if (Number(value) > 31) {
            return callback(new Error('输入时长限制为1-31'));
          }
        } else if (this.form.cycleType == '周') {
          if (Number(value) > 52) {
            return callback(new Error('输入时长限制为1-52'));
          }
        } else if (this.form.cycleType == '月') {
          if (Number(value) > 12) {
            return callback(new Error('输入时长限制为1-12'));
          }
        } callback()
      }
    };
    let checkPracticeTime = (rule, value, callback) => {
      if (!this.form.one || !this.form.two) {
        return callback(new Error('请填写时长'));
      } else {
        let valiReg = /^[0-9]\d*$/
        if (!valiReg.test(this.form.one) || !valiReg.test(this.form.two)) {
          return callback(new Error('请输入整数'));
        } else if (Number(this.form.one) >= Number(this.form.two)) {
          return callback(new Error('范围输入有误'));
        } callback()
      }
    };
    return {
      showTutorial: false,
      // selectChapter: [],
      addChapterData: [],
      coursearr: [],
      catalog: [],
      form: {
        attrs: 2,
        moduleCode: "JRTX",
        isTop: 2,
        shortDaysType: "天",
        startIntervalType: "天",
        three: "秒",
        daysType: "天"
      },
      rules: {
        courseName: [
          { required: true, message: "请选择训练教程", trigger: "blur" }
        ],
        // addChapterData: [
        //   { required: true, message: "请选择教程章节", trigger: "blur" }
        // ],
        days: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value != "") {
                if (!/^([1-9]\d*|[0]{1,1})$/.test(value)) {
                  callback(new Error("请填写大于等于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写训练总时长"));
              }
            },
            trigger: "blur"
          }
        ],
        daysType: [{ required: true, message: "请选择", trigger: "blur" }],
        // three: [{ required: true, message: "请输入范围", trigger: "blur" }],
        three: [{ required: true, validator: checkPracticeTime, trigger: 'blur' }],
        // cycle: [{ required: true, message: "请选择频率", trigger: "blur" }],
        cycle: [{ required: true, validator: checkCycle, trigger: 'blur' }],
        attrs: [{ required: true, message: "请选择", trigger: "blur" }],
        shortDays: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value != "") {
                if (!/^([1-9]\d*|[0]{1,1})$/.test(value)) {
                  callback(new Error("请填写大于等于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写短期训练属性"));
              }
            },
            trigger: "blur"
          }
        ],
        shortDaysType: [{ required: true, message: "请选择", trigger: "blur" }],
        startTimeType: [
          { required: true, message: "请选择方案开始时间", trigger: "blur" }
        ],
        startIntervalTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value != "" || value === 0) {
                if (!/^([1-9]\d*|[0]{1,1})$/.test(value)) {
                  callback(new Error("请填写大于等于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写开始时间间隔"));
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    formData(val) {
      this.form = val;
      let str = this.form.duration.split(",");
      this.form.one = str[0];
      this.form.two = str[1];
      this.form.three = str[2];
      this.addChapterData = []
      this.showTutorial = false
      this.form.projectDTOList.forEach(v => {
        this.addChapterData.push({
          chapterNo: v.chapterNo,
          label: v.refName,
          type: v.type,
          id: v.id,
          courseId: this.form.courseId,
          isSelect: true,
          // subChapters: [],
          // children: [],

          pushRefId: v.refId,
          pushRefName: this.form.courseName,
          pushType: 4,
          name: v.refName

        })
      })
    }
  },
  created() {
    this.trainCourse();
  },
  methods: {
    closeChapter() {
      this.showTutorial = false
    },
    updateChoseChapter() {
      // console.log(this.addChapterData)
      this.$store.commit("chapter_ARR", this.addChapterData);
      this.$store.commit("course_Id", this.form.courseId);
      this.showTutorial = true
    },
    choseChapter() {
      if (!this.form.courseName) {
        this.$message.error('请选择训练教程')
        return
      }
      this.showTutorial = true
    },
    receiveTutorial(data) {
      // console.log(data,'receiveTutorial数据')
      // // this.selectTotal = data.selectTotal;
      // this.selectChapter = data.selectAll
    },
    resetChoose() {
      // this.$store.commit("chapter_ARR", [])
      this.$refs.addtrainingComp.resetChooseEvent()
    },
    confirmAdd() {
      // 获取子组件的数据
      // console.log(this.$refs.addtrainingComp.selectAll)
      let selectData = this.$refs.addtrainingComp.selectAll
      // 删除行
      for (let i = 0; i < selectData.length; i++) {
        if (selectData[i].refNameRed) {  // 被删的章节
          selectData.splice(i, 1)
          i = i - 1
        }
      }
      this.showTutorial = false
      this.addChapterData = selectData
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (this.form.itemTime != '' && (this.form.itemTime < 1 || this.form.itemTime > 10)) {
          this.$message.error("提醒时间不能大于10并且不能小于1");
          return false;
        } else {
          this.form.remindDate = this.$dayTimeFun(this.form.itemTime);
        }
        if (valid) {
          // 教程章节数据
          this.form.projectDTOList = []
          this.addChapterData.forEach(v => {
            this.form.projectDTOList.push({
              refId: v.id,
              refName: v.name,
              chapterNo: v.chapterNo,
              type: 2
            })
          })
          if (!this.addChapterData.length) {
            this.$message.error("请选择教程章节");
            return;
          }
          this.form.schemeType = local.get("ADDRESS");
          this.form.duration =
            this.form.one + "," + this.form.two + "," + this.form.three;
          if (
            !/^([1-9]\d*|[0]{1,1})$/.test(this.form.one) ||
            !/^([1-9]\d*|[0]{1,1})$/.test(this.form.two)
          ) {
            this.$message.error("单次训练时长必须0或者正整数");
            return;
          }
          if (Number(this.form.one) >= Number(this.form.two)) {
            this.$message.error("单次训练时长第一个必须小于第二个~");
            return;
          }
          if (this.form.attrs == 1) {
            this.form.shortDays = "";
          }
          this.$emit("updateTemplate", this.form);
        } else {
          return false;
        }
      });
    },
    /**
     * @description:  获取培训教程
     * @param {*}
     * @return {*}
     */
    trainCourse() {
      api_get_train_course({ available: 1 }).then(res => {
        this.coursearr = res.data;
      });
    },
    //选中培训教程后获取教程章节
    chosecourse(event) {
      // this.selectChapter = []
      this.addChapterData = []
      this.showTutorial = false

      this.form.courseName = event.name;
      this.form.courseId = event.id
      this.form.itemName = "";
      if (event.id) {
        this.$store.commit("chapter_ARR", []);
        this.$store.commit("course_Id", event.id);
      }
      // api_get_train_chapter({
      //   courseId: event.id
      // }).then(res => {
      //   this.catalog = res.data;
      // });
    },
    chosecourseOne(event) {
      this.form.refId = event.id;
      this.form.itemName = this.form.itemName.name;
    },
    change(e) {
      this.$forceUpdate();
    },
    itemTimeChange(e) {
      //提醒时间
      this.form.itemTime = e.replace(/[^\d]/g, "");
      // if (e === "0" || e > 10) {
      //   this.$message.error("提醒时间不能大于10并且不能小于1");
      // }
    }
  }
};
</script>

<style lang="less">
.plan-model {
  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }
}
</style>

<style lang="less" scoped>
@import "./index.less";
.training-wrapper {
  display: flex;
  width: unset;
  .select-chapter {
    border-right: 2px solid #FFFFFF;
    padding: 0px 40px;
  }
  .close-chapter {
    font-size: 30px;
    font-weight: 700;
    text-align: right;
    position: relative;
    height: 50px;
    span {
      position: absolute;
      right: -20px;
      top: 0;
    }
  }
  .header{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p{
      width: 4px;
      height: 15px;
      background: #1A7BFC;
      margin-right: 12px;
    }
    h1{
      font-size: 14px;
      font-weight: bolder;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
    }
  }
}
</style>